var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
/**
 * Call-to-action button that is shown when an action is possible,
 * actions are: buy ticket, match report, live ticker link
 * @constructor
 */
export function MatchCallToActionButton(_a) {
    var reportId = _a.reportId, buyTicketLink = _a.buyTicketLink, liveTickerKey = _a.liveTickerKey;
    var _b = useState(null), label = _b[0], setLabel = _b[1];
    var _c = useState("text"), buttonVariant = _c[0], setButtonVariant = _c[1];
    var _d = useState("primary"), buttonColor = _d[0], setButtonColor = _d[1];
    var _e = useState(""), url = _e[0], setUrl = _e[1];
    var theme = useTheme();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    useEffect(function () {
        if (reportId) {
            setLabel({
                sl: "Poročilo s tekme",
                en: "Match report"
            });
            setButtonVariant("outlined");
            setButtonColor("inherit");
            setUrl("/news/" + reportId);
        }
        else if (liveTickerKey) {
            setLabel({
                sl: "V živo",
                en: "Live"
            });
            setButtonVariant("contained");
            setButtonColor("error");
            setUrl("/live-ticker/" + liveTickerKey);
        }
        else if (buyTicketLink) {
            setLabel({
                sl: "Kupi vstopnico",
                en: "Buy ticket"
            });
            setButtonVariant("contained");
            setButtonColor("primary");
            setUrl(buyTicketLink);
        }
        else {
            setLabel(null);
            setButtonVariant("text");
        }
    }, [liveTickerKey, buyTicketLink, reportId]);
    return (_jsx(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "center" }, { children: _jsx(Button, __assign({ component: Link, viewTransition: true, to: url, target: url.startsWith("https://") ? "_blank" : undefined, sx: {
                borderRadius: "24px",
                border: reportId ? "1px solid ".concat(theme.palette.text.primary) : null,
                px: 2,
            }, variant: buttonVariant, color: buttonColor }, { children: _jsx(Typography, __assign({ variant: "gumbS" }, { children: label && getLocalizedString(label, currentLang) })) })) })));
}
